import { keyframes, SxProps, Theme } from '@mui/material'

const spin = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const audioRecordStyles: Record<string, SxProps<Theme>> = {
  audioWrap: {
    justifyContent: 'flex-start',
    width: '100%',
    padding: (theme) => theme.spacing(1, 2),
    borderRadius: '4px',
    border: '1px solid #E0E0E0',
  },
  flexBox: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  innerText: {
    marginLeft: 2,
    color: (theme) => theme.palette.common.black,
    userSelect: 'none',
  },
  recordText: {
    animation: `${spin} 2s infinite ease`,
  },
  recordTime: {
    marginRight: 1.5,
    marginLeft: 'auto',
  },
  iconBox: {
    width: '34px',
    height: '34px',
    padding: 0,
    '& svg': {
      width: '100%',
    },
  },
  sliderStyle: {
    mx: (theme) => theme.spacing(1.5),
  },
  mr12: {
    marginRight: 1.5,
  },
}

export default audioRecordStyles
